function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "lens1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0 0 L 299 0 L 299 299.25 L 0 299.25 Z M 0 0 "
})));

function SvgLensIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    viewBox: "0 0 300 299.999988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "lensicon"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lens1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.649231%,60.389709%,61.959839%)",
      fillOpacity: 1
    },
    d: "M 238.1875 217.785156 C 280.238281 165.175781 276.929688 88.003906 228.210938 39.285156 C 202.878906 13.953125 169.199219 0 133.371094 0 C 97.542969 0 63.863281 13.953125 38.527344 39.285156 C 13.195312 64.621094 -0.753906 98.300781 -0.753906 134.128906 C -0.753906 169.953125 13.195312 203.636719 38.53125 228.96875 C 63.863281 254.304688 97.546875 268.253906 133.371094 268.253906 C 164.160156 268.253906 193.347656 257.925781 217.03125 238.949219 L 272.949219 294.867188 C 275.871094 297.789062 279.699219 299.25 283.53125 299.25 C 287.359375 299.25 291.1875 297.789062 294.109375 294.867188 C 299.953125 289.023438 299.953125 279.550781 294.109375 273.707031 Z M 59.691406 207.8125 C 40.007812 188.128906 29.167969 161.964844 29.167969 134.128906 C 29.167969 106.296875 40.007812 80.128906 59.691406 60.445312 C 79.371094 40.765625 105.539062 29.925781 133.371094 29.925781 C 161.203125 29.925781 187.371094 40.765625 207.050781 60.445312 C 247.679688 101.074219 247.679688 167.175781 207.058594 207.808594 C 207.054688 207.808594 207.054688 207.8125 207.050781 207.8125 C 207.050781 207.816406 207.046875 207.816406 207.046875 207.820312 C 187.363281 227.492188 161.199219 238.328125 133.371094 238.328125 C 105.539062 238.328125 79.371094 227.488281 59.691406 207.8125 Z M 59.691406 207.8125 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLensIcon);
export default __webpack_public_path__ + "static/media/LensIcon.b5f22108.svg";
export { ForwardRef as ReactComponent };